import { render, staticRenderFns } from "./FormDetailRow.vue?vue&type=template&id=60f2738c&"
import script from "./FormDetailRow.vue?vue&type=script&lang=js&"
export * from "./FormDetailRow.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports